import { useEffect, useState } from 'react';
import { SITE_TYPE_CHANGE_EVENT, getSiteType } from '../utils/siteType';

// Current navbar site type, kept in sync with the select while the page is open.
export default function useSiteType() {
  const [siteType, setSiteType] = useState(getSiteType);

  useEffect(() => {
    const syncSiteType = () => setSiteType(getSiteType());
    window.addEventListener(SITE_TYPE_CHANGE_EVENT, syncSiteType);
    return () => window.removeEventListener(SITE_TYPE_CHANGE_EVENT, syncSiteType);
  }, []);

  return siteType;
}
